/**
 * Configuration for the Aggregates API
 */
export default {
	id: 'aggregatesV2',
	name: 'Aggregates',
	resultsTitle: 'Recommendations',
	version: 'v2',
	fields: [
		{
			name: 'Remove Duplicates',
			placeholder: '',
			required: false,
			value: true,
			id: 'removeDuplicates',
			type: 'bool',
		},
		{
			name: 'Sources',
			placeholder: 'Enter sources...',
			required: false,
			value: null,
			id: 'sourceFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/brands',
		},
		{
			name: 'Exclude Ids',
			placeholder: 'Enter excluded ids...',
			required: false,
			value: null,
			id: 'excludeIds',
			type: 'csv',
		},
		{
			name: 'Size',
			placeholder: 'Enter size...',
			required: false,
			value: 10,
			id: 'size',
			type: 'number',
		},
		{
			name: 'Exclude Affiliate Content',
			placeholder: '',
			required: false,
			value: false,
			id: 'excludeAffiliateContent',
			type: 'bool',
		},
		{
			name: 'Blocks',
			placeholder: '',
			required: true,
			value: [
				{
					id: 0,
					name: '',
					docTypeFilter: null,
					variantFilter: null,
					startDate: null,
					size: null,
					endDate: null,
					orderBy: 'Relevance',
					facets: null,
				},
			],
			id: 'blocks',
			type: 'aggregateBlocksV2',
		},
	],
};
